import React from "react";

function Footer() {
  return (
    <footer>
      <div className="container">
        <div className="footer-content">
          <a
            target="_blank"
            rel="noreferrer"
            href="https://x.com/dogemax_ai/status/1875713416268054825?t=8AWBGN0IA8ZRmN3NBzX1bA&s=19"
          >
            <svg
              width="54"
              height="54"
              viewBox="0 0 54 54"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                opacity="0.2"
                y="0.473633"
                width="53.2632"
                height="53.2632"
                rx="10.6526"
                fill="#030133"
              />
              <g clip-path="url(#clip0_21_636)">
                <path
                  d="M36.183 13.0508H41.0635L30.4035 25.3162L42.99 41.9484H33.1006L25.3946 31.8663L16.5327 41.9484H11.6522L23.0828 28.8481L11.01 13.0508H21.1563L28.1559 22.298L36.183 13.0508ZM34.4492 38.9944H37.1463L19.6793 15.8121H16.7253L34.4492 38.9944Z"
                  fill="#030133"
                />
              </g>
              <defs>
                <clipPath id="clip0_21_636">
                  <rect
                    width="31.98"
                    height="28.8976"
                    fill="white"
                    transform="translate(11.01 13.0508)"
                  />
                </clipPath>
              </defs>
            </svg>
          </a>
          <a target="_blank" rel="noreferrer" href="https://t.me/dogemax_ai">
            <svg
              width="54"
              height="54"
              viewBox="0 0 54 54"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                opacity="0.2"
                y="0.473633"
                width="53.2632"
                height="53.2632"
                rx="10.6526"
                fill="#030133"
              />
              <path
                d="M13.5 27L40.5 14L34.125 37.125L27 32.625L23.625 36.75L24.75 29.625L13.5 27ZM25.5 28.125L33.75 32.625L38.25 17.25L25.5 28.125Z"
                fill="#030133"
              />
            </svg>
          </a>

          <a href="link">
            <svg
              width="54"
              height="54"
              viewBox="0 0 54 54"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                opacity="0.2"
                y="0.473633"
                width="53.2632"
                height="53.2632"
                rx="10.6526"
                fill="#030133"
              />
              <path
                d="M36.9 18.6C34.7404 17.7596 32.475 17.1382 30.138 16.757C29.676 17.496 29.1126 18.369 28.5606 19.095C25.7766 18.777 22.8984 18.777 20.1162 19.095C19.5624 18.369 18.999 17.496 18.537 16.757C16.2006 17.1382 13.935 17.7606 11.775 18.6C9.4506 23.193 8.4126 27.6 8.7 31.95C11.553 34.149 14.406 35.517 17.3676 36.552C18.288 35.466 19.08 34.293 19.7538 33.063C18.2958 32.553 16.959 31.809 15.8088 30.855C16.0356 30.6918 16.2654 30.5274 16.497 30.363C20.1732 32.277 24.5748 33.2598 28.9986 32.976C33.4236 33.2598 37.8252 32.277 41.5014 30.363C41.733 30.5274 41.9628 30.6918 42.1896 30.855C41.0406 31.809 39.7038 32.553 38.2464 33.063C38.92 34.293 39.7122 35.466 40.6326 36.552C43.5942 35.517 46.4472 34.149 49.3 31.95C49.5864 27.6 48.549 23.193 46.2246 18.6ZM19.575 29.31C18.279 29.31 17.235 28.11 17.235 26.631C17.235 25.152 18.27 23.952 19.575 23.952C20.88 23.952 21.915 25.152 21.915 26.631C21.915 28.11 20.871 29.31 19.575 29.31ZM36.765 29.31C35.469 29.31 34.425 28.11 34.425 26.631C34.425 25.152 35.46 23.952 36.765 23.952C38.07 23.952 39.105 25.152 39.105 26.631C39.105 28.11 38.061 29.31 36.765 29.31Z"
                fill="#030133"
              />
            </svg>
          </a>
        </div>
        <p>Copyright © 2024 DogeMax.</p>
      </div>
    </footer>
  );
}

export default Footer;
